class Modal {

	constructor() {

		const modalCandidate = document.querySelector("#formCandidate");
		const titleCandidate = document.querySelector("[data-job]");

		if( modalCandidate ) {

			modalCandidate.addEventListener('shown.bs.modal', event => {
				let inputJob = modalCandidate.querySelector('input[name="f_job"]');
				inputJob.value = titleCandidate.dataset.job;
				inputJob.closest('.form-field').classList.add('filled');
			});

		}

	}

}